import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/project-management")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/project-management"),
  component: PVOffering,
});

